<template>
    <div>
    <v-dialog v-model="visualizar" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ instalacion.nombre }}</span>
          <v-spacer></v-spacer>
         
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="instalacion.nombre" label="Nombre" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="instalacion.comuna" label="Comuna" required outlined></v-text-field>
              </v-col>              
              <v-col cols="4">
                <v-text-field v-model="instalacion.region" label="Region" required outlined></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field v-model="instalacion.direccion" label="Direccion" required outlined></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-text-field v-model="instalacion.telefono" label="Telefono" outlined type="number"></v-text-field>
              </v-col>
              <v-col cols="3">
                <v-select :items="clientes" v-model="instalacion.contrato" label="Cliente" outlined></v-select>
              </v-col>
              <v-col cols="3">
                <v-select :items="contratos" v-model="instalacion.cliente" label="Contrato" outlined></v-select>
              </v-col>
              <v-col cols="3">
                <v-select :items="servicios" v-model="instalacion.servicio" label="Servicio" outlined></v-select>
              </v-col>                            
 
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="close()">Cancelar</v-btn>
          <v-btn color="blue darken-1" text @click="presave">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    </div>
</template>
<script>
import api from "../conf/ruta-base"
import moment from "moment";
import axios from 'axios';
import swal from "sweetalert";
moment.locale('es');
export default {
    data() {
        return {
            instalacion:{},
            clienteDefault: {},
            contratos:[],
            clientes:[],
            servicios:[]
        }
    },
  props: {
    editedItem: {
      type: Object,
      default: null
    },
    editedIndex: {
        type: Number,
        default: -1
    },
    visualizar: {
        type: Boolean,
        default: false,
    }
  },
  watch:{
    editedItem(data){
        if(data) this.cliente = data;
    },
  },
  methods: {
    //Metodo que se trae la informacion de la fecha formato mysql y la retorna local
    momento(fecha){
      return moment(fecha).format('L')
    },
    //empuja el archivo al componente padre
    onFileCharge(){
        this.$emit('cargaArchivos',this.chosenFile)
        this.chosenFile = null
    },
    close(){
        this.$emit('close',false)
    },
    presave(){
        if(!this.instalacion.nombre || !this.instalacion.direccion || !this.instalacion.telefono) {
            console.log(this.instalacion)
            swal('','Los campos de identificacion son obligatorios','error'); return;
        }
        if(!this.instalacion.comuna || !this.instalacion.region || !this.instalacion.nombre) {
            swal('','Los campos de ubicacion son obligatorios','error'); return;
        }
        if(!this.instalacion.contrato || !this.instalacion.cliente || !this.instalacion.servicio) {
            swal('','Los campos de relacion son obligatorios','error'); return;
        }
        if(this.editedIndex == -1){
            axios.post(`${api.api}instalaciones`,this.instalacion).then(res=>{
                this.$emit('cargaInstalaciones',res.data)
                this.$emit('close',false)
                swal('','instalacion guardado','success');
            }).catch(err=>{
                swal('','Error al guardar instalacion','error');
            })
        }else{
            axios.put(`${api.api}instalaciones/${this.instalacion.id}`,this.instalacion).then(res=>{
                this.$emit('cargaInstalaciones',this.instalacion)
                //this.$emit('close',false)
                swal('','Cliente actualizado','success');
            }).catch(err=>{
                swal('','Error al actualizar Cliente','error');
            })
        }
    },
  },
  mounted(){
    axios.get(`${api.api}clientes`).then(res=>{
        res.data.forEach(cliente => {
          this.clientes.push({text: `${cliente.razonSocial} - ${cliente.giro}`, value: cliente.id})
        });
    }).catch(err=>{
        swal('','Error al traer los datos de clientes.','error');
    })

    axios.get(`${api.api}contratos`).then(res=>{
        res.data.forEach(contrato => {
          this.contratos.push({text: `${contrato.descripcion} - ${contrato.licitacion}`, value: contrato.id})
        });
    }).catch(err=>{
        swal('','Error al traer los datos de los contratos','error');
    })
    
    axios.get(`${api.api}servicios`).then(res=>{
        res.data.forEach(servicio => {
          this.servicios.push({text: `${servicio.nombre} - ${servicio.descripcion}`, value: servicio.id})
        });
    }).catch(err=>{
        swal('','Error al traer los datos de servicios','error');
    })    
  }
}
</script>